import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Dropdown, DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { Download, Settings, Upload } from '@factorialco/f0-react/icons/app'
import { CompensationsPayrollRunQuery, PayrollResultFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export type PayrollRunActionsProps = {
  onExportClick: () => void
  onManagePayrollResultsClick?: () => void
  data: CompensationsPayrollRunQuery
  payrollResults: PayrollResultFragment[]
  canExportCompensations?: boolean
  isClosed?: boolean
  isCyclesManagementFeatureEnabled: boolean
}

export function PayrollRunActions({
  onExportClick,
  data,
  payrollResults = [],
  onManagePayrollResultsClick,
  canExportCompensations,
  isClosed,
  isCyclesManagementFeatureEnabled,
}: PayrollRunActionsProps) {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const payrollRunId = data.compensations?.payrollRunsConnection.nodes[0]?.id

  const canImportCompensations =
    data.universalImporter?._policies.importResources.can &&
    data.compensations?._policies?.employeeCompensationBulkImport?.can &&
    payrollRunId !== null &&
    payrollRunId !== undefined

  const canImportResults =
    data.compensations?._policies?.payrollResultImport?.can &&
    payrollRunId !== null &&
    payrollRunId !== undefined

  const showImportResults = !!(canImportCompensations && canImportResults)

  const onClickImportItem = () => {
    navigate(
      navigation.compensations.definition.importResult
        .fullPath()
        .replace(/\*+$/, '')
        .concat(`?payroll-run-id=${payrollRunId}`)
    )
  }

  const itemDropdown: DropdownItem[] = []

  if (!isClosed) {
    itemDropdown.push({
      label: i18n.t('compensation.routes.employee_compensations_universal_importer'),
      icon: Upload,
      onClick: () =>
        navigate(
          navigation.compensations.definition.importCompensations
            .fullPath()
            .replace(/\*+$/, '')
            .concat(`?payroll-run-id=${payrollRunId}`)
        ),
    })
  }

  if (showImportResults && payrollResults.length === 0) {
    itemDropdown.push({
      label: i18n.t('compensations.PayrollRunCompensationsList.import_result.title'),
      icon: Upload,
      onClick: onClickImportItem,
    })
  }

  if (showImportResults && payrollResults.length > 0) {
    itemDropdown.push({
      label: i18n.t('compensations.PayrollRunCompensationsList.manage_payroll_results.button'),
      icon: Settings,
      onClick: onManagePayrollResultsClick,
    })
  }

  return (
    <Box flexDirection="row" gap="s12" alignSelf="flexEnd">
      {showImportResults && <Dropdown items={itemDropdown} />}

      {!isCyclesManagementFeatureEnabled && canExportCompensations && (
        <F0Button
          onClick={onExportClick}
          label={i18n.t('compensations.PayrollRunCompensationsList.export_data')}
          icon={Download}
          variant="default"
        />
      )}
    </Box>
  )
}
